
import React from 'react';
import { ResponsiveImage as ResponsiveImageUtil } from '../../utils/image';

interface ResponsiveImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  sizes?: string;
  loading?: 'lazy' | 'eager';
  widths?: number[];
  wrapperClassName?: string;
  onLoad?: () => void;
  onError?: () => void;
}

const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  wrapperClassName = '',
  onLoad,
  onError,
  ...props
}) => {
  return (
    <div className={wrapperClassName || ''}>
      <ResponsiveImageUtil
        {...props}
      />
    </div>
  );
};

export default ResponsiveImage;
